// Logout.cshtml of both apps: end the session (the API ends it and clears its cookie), then the sign-in page.
import { api, hasAccessToken, refresh, setAccessToken } from '../bff';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export function LogoutPage() {
  const client = useQueryClient();
  const navigate = useNavigate();
  useEffect(() => {
    let done = false;
    const finish = () => {
      if (done) return;
      done = true;
      setAccessToken(null);
      client.clear();
      navigate('/login', { replace: true });
    };
    // after a reload the access token is gone: get one from the cookie first, so the API can end that session
    (hasAccessToken() ? Promise.resolve(true) : refresh())
      .then(() => api('POST', '/auth/logout', { body: {} }))
      .then(finish, finish);
  }, [client, navigate]);
  return null;
}
